"use client";

import { c as _c } from "react/compiler-runtime";
import { type Locale, localizePath } from "@lib/i18n/locale";
import { getArticlePath } from "@lib/routing";
import { ArticleCardList } from "@modules/article/components/ArticleCard";
import { useHubSearch } from "@modules/hub/components/HubSearch";
import { useTranslations } from "next-intl";
import type { ReactNode } from "react";
const SearchResults = t0 => {
  const $ = _c(18);
  const {
    locale,
    category,
    children
  } = t0;
  const t = useTranslations("hub");
  const tArticle = useTranslations("article");
  const {
    outcome,
    busy,
    submit
  } = useHubSearch();
  let t1;
  let teasers;
  if ($[0] !== category || $[1] !== outcome || $[2] !== t) {
    teasers = outcome && "teasers" in outcome ? outcome.teasers : [];
    t1 = !outcome ? null : "failed" in outcome ? t("search_failed") : !teasers.length ? t("search_empty", {
      query: outcome.query
    }) : category ? t("search_results_in", {
      count: teasers.length,
      query: outcome.query,
      category
    }) : t("search_results", {
      count: teasers.length,
      query: outcome.query
    });
    $[0] = category;
    $[1] = outcome;
    $[2] = t;
    $[3] = t1;
    $[4] = teasers;
  } else {
    t1 = $[3];
    teasers = $[4];
  }
  const summary = t1;
  const t2 = `transition-opacity ${busy ? "opacity-60" : ""}`;
  let t3;
  if ($[5] !== children || $[6] !== locale || $[7] !== outcome || $[8] !== submit || $[9] !== summary || $[10] !== t || $[11] !== tArticle || $[12] !== teasers) {
    t3 = outcome ? <><div className="mt-2m flex flex-wrap items-baseline gap-x-s gap-y-2xs"><p className="text-body-1 font-book text-neutral-425 m-none">{summary}</p><button type="button" onClick={() => submit("")} className="p-none bg-transparent border-none cursor-pointer rounded-xs text-body-2 font-semibold text-primary-800 underline underline-offset-2 hover:text-primary-825 focusable">{t("search_reset")}</button></div>{teasers.length > 0 && <ArticleCardList cards={teasers.map(teaser => ({
        teaser,
        href: localizePath(locale, getArticlePath(locale, teaser.slug)),
        readingTime: teaser.readingTime ? tArticle("reading_time", {
          minutes: teaser.readingTime
        }) : null
      }))} />}</> : children;
    $[5] = children;
    $[6] = locale;
    $[7] = outcome;
    $[8] = submit;
    $[9] = summary;
    $[10] = t;
    $[11] = tArticle;
    $[12] = teasers;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== busy || $[15] !== t2 || $[16] !== t3) {
    t4 = <div aria-live="polite" aria-busy={busy} className={t2}>{t3}</div>;
    $[14] = busy;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
};
export default SearchResults;